import React from "react";
import {StandList} from "../StandList/StandList";
import {connect} from "react-redux";
import {openDialogAction} from "../../../comun/DialogManager/DialogManagerAction";
import {getStands} from "../StandAction";
import {StandFilters} from "../../Stand/StandFilter/StandFilter";



export let ManageStandFilter = ({stand, ...props}) => {
    return (
        <StandList title="Gestionar Stands"  action={getStands}/>
    )
}


const mapStateToProps = (state) => {
    return {
        stand: state.stand
    };
}
ManageStandFilter = connect(mapStateToProps, null)(ManageStandFilter);


